export class TaxResultItemType {
  taxResultItemTypeId!: number;
  name!: string;
}
